export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_domaya-home/artifacts/55nnx732_Domaya%20app%20logo.png",
  screenToday: "/screens/today.png",
  screenPantry: "/screens/pantry.png",
  screenHome: "/screens/home.png",
  screenHousehold: "/screens/household.png",
};

export const CONTACT_EMAIL = "founder@domaya.app";
export const DOMAIN = "domaya.app";
